import React from 'react';
import { Alert } from '@innovationnorway/cl-react';
import useMaintenance from 'src/features/maintenance/hooks/use-maintenance';

import './MaintenanceBanner.scss';

const MaintenanceBanner: React.FC = () => {
  const { isMaintenanceActive, notificationText } = useMaintenance();

  if (!notificationText && !isMaintenanceActive) return <></>;

  return (
    <div className={isMaintenanceActive ? 'maintenance-banner' : ''}>
      {notificationText && (
        <Alert data-color="info" closeButton>
          {notificationText}
        </Alert>
      )}
    </div>
  );
};

export default MaintenanceBanner;
